type ExtraTripInterval = {
	dateRange?: { startDate?: string; endDate?: string };
};

export function extraTripTodayKey(now = new Date()): string {
	return new Intl.DateTimeFormat('en-CA', {
		timeZone: 'America/Sao_Paulo',
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	}).format(now);
}

export function intervalIsOnlyToday(
	interval: ExtraTripInterval,
	now = new Date(),
): boolean {
	const today = extraTripTodayKey(now);
	const startDate = interval.dateRange?.startDate;
	if (!startDate) {
		return false;
	}
	const endDate = interval.dateRange?.endDate ?? startDate;
	return startDate === today && endDate === today;
}

export function shouldLockIntervalTransport(
	interval: ExtraTripInterval,
	isEmergencyFlow: boolean,
	now = new Date(),
): boolean {
	return isEmergencyFlow || intervalIsOnlyToday(interval, now);
}

export function transportLockMessage(
	isEmergencyFlow: boolean,
	hasOnlyTodayInterval: boolean,
): string | null {
	if (isEmergencyFlow) {
		return 'Não é possível solicitar transporte no fluxo emergencial.';
	}
	if (hasOnlyTodayInterval) {
		return 'Ao solicitar ida extra para hoje, não é possível solicitar transporte.';
	}
	return null;
}
